import type { FC } from 'react';
import { Trans } from 'react-i18next';

import { IconComponent } from '@/components/IconComponent';

interface IGameErrorNotAvailCurrencyProps {
  availableCurrency: string;
}

export const GameErrorNotAvailCurrency: FC<IGameErrorNotAvailCurrencyProps> = ({
  availableCurrency,
}) => (
  <>
    <div className="lock">
      <IconComponent name="lockIcon" size="32px" />
    </div>
    <p>
      <Trans
        components={{ 2: <strong /> }}
        i18nKey="noCurrency"
        ns="common"
        values={{ currency: availableCurrency }}
      />
    </p>
  </>
);
